import React from 'react';
import './Announcement.css'

const Announcement = ( { myAnnouncement } ) => {
  return (
    <div className='announcement__container'>
        <div className='announcement'>
            <h1>{myAnnouncement}</h1>
        </div>
    </div>
  )
}

export default Announcement
